module.exports = __webpack_public_path__ + "img/grand.bb6c3423.png";